import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class B2BPlantNavService {
    constructor(private readonly router: Router) {}

    goToPlantDetails(plantId: number | string): void {
        this.router.navigate(['/plants', 'plants-detail', plantId]);
    }
}
